import mapArcade from '../assets/map-images/map-arcade.png'
import gameIconLight from '../assets/map-icons/courtney-map-icon_game-light.png'
import gameIconDark from '../assets/map-icons/map-icon_game-dark.png'

import mapBookShelf from '../assets/map-images/map-book-shelf.png'
import bookIconLight from '../assets/map-icons/map-icon_book-light.png'
import bookIconDark from '../assets/map-icons/map-icon_book copy 2.png'

import mapCinema from '../assets/map-images/map-cinema.png'
import cinemaIconLight from '../assets/map-icons/map-icon_movie-light.png'
import cinemaIconDark from '../assets/map-icons/map-icon_movie-dark.png'

import mapElectronics from '../assets/map-images/map-electronics.png'
import electronicsIconLight from '../assets/map-icons/courtney-map-icon_salon-light-1.png'
import electronicsIconDark from '../assets/map-icons/map-icon_electroincs-dark.png'

import mapFoodCourt from '../assets/map-images/map-food-court.png'
import foodIconLight from '../assets/map-icons/map-icon_food-light.png'
import foodIconDark from '../assets/map-icons/map-icon_food-dark.png'

import mapMeetingArea from '../assets/map-images/map-meeting-area.png'
import meetingIconLight from '../assets/map-icons/map-icon_meeting-area-light.png'
import meetingIconDark from '../assets/map-icons/map-icon_meeting-area-dark.png'

import mapMusic from '../assets/map-images/map-music.png'
import musicIconLight from '../assets/map-icons/courtney-map-icon_music-light.png'
import musicIconDark from '../assets/map-icons/map-icon_music-dark.png'

import mapSalon from '../assets/map-images/map-salon.png'
import salonIconLight from '../assets/map-icons/courtney-map-icon_salon-light.png'
import salonIconDark from '../assets/map-icons/map-icon_salon-dark.png'

import mapClothing from '../assets/map-images/map-clothing.png'
import clothingIconLight from '../assets/map-icons/courtney-map-icon_valaries-light.png'
import clothingIconDark from '../assets/map-icons/map-icon_valaries-dark.png'

export const arcadeImages = {
  mapImage: mapArcade,
  lightIcon: gameIconLight,
  darkIcon: gameIconDark
}

export const bookImages = {
  mapImage: mapBookShelf,
  lightIcon: bookIconLight,
  darkIcon: bookIconDark,
}

export const cinemaImages = {
  mapImage: mapCinema,
  lightIcon: cinemaIconLight,
  darkIcon: cinemaIconDark
}

export const electronicsImages = {
  mapImage: mapElectronics,
  lightIcon: electronicsIconLight,
  darkIcon: electronicsIconDark
}

export const foodCourtImages = {
  mapImage: mapFoodCourt,
  lightIcon: foodIconLight,
  darkIcon: foodIconDark
}

export const meetingAreaImages = {
  mapImage: mapMeetingArea,
  lightIcon: meetingIconLight,
  darkIcon: meetingIconDark
}

export const musicImages = {
  mapImage: mapMusic,
  lightIcon: musicIconLight,
  darkIcon: musicIconDark
}

export const salonImages = {
  mapImage: mapSalon,
  lightIcon: salonIconLight,
  darkIcon: salonIconDark
}

export const clothingImages = {
  mapImage: mapClothing,
  lightIcon: clothingIconLight,
  darkIcon: clothingIconDark
}
